<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="flex justify-between flex-col h-full">
  <div class="text-ladder-black">
    <h1 class="font-bold text-3xl">Email Confirmed!</h1>
    <div class="text-base opacity-80">
      <p class="mt-2">
        Now that your email is confirmed, please create a password.
      </p>
      <div class="mt-4">
        <div class="form-group mb-3">
          <label for="password">Password</label>
          <div class="relative">
            <input
              formControlName="password"
              autocapitalize="off"
              id="password"
              placeholder="&#x2022; &#x2022; &#x2022; &#x2022; &#x2022;"
              [type]="showPassword ? 'text' : 'password'"
            />
            <button
              type="button"
              class="absolute inset-y-0 right-4 flex items-center"
              (click)="showPassword = !showPassword"
            >
              <span
                [class]="showPassword ? 'mdi--eye-off' : 'mdi--eye'"
                class="iconify mdi--eye text-2xl text-[#A6A6A6]"
              ></span>
            </button>
          </div>
          <div *ngIf="resetPasswordForm.get('password')?.invalid && resetPasswordForm.get('password')?.touched" class="text-red-600 text-sm mt-1">
            <span *ngIf="resetPasswordForm.get('password')?.errors?.['required']">Password is required.</span>
            <span *ngIf="resetPasswordForm.get('password')?.errors?.['minlength']">Password must be at least 6 characters.</span>
          </div>
        </div>
        <div class="form-group mb-3">
          <label for="confirm-password">Confirm Password</label>
          <div class="relative">
            <input
              formControlName="confirmPassword"
              autocapitalize="off"
              id="confirm-password"
              placeholder="&#x2022; &#x2022; &#x2022; &#x2022; &#x2022;"
              [type]="showConfirmPassword ? 'text' : 'password'"
            />
            <button
              type="button"
              class="absolute inset-y-0 right-4 flex items-center"
              (click)="showConfirmPassword = !showConfirmPassword"
            >
              <span
                [class]="showConfirmPassword ? 'mdi--eye-off' : 'mdi--eye'"
                class="iconify mdi--eye text-2xl text-[#A6A6A6]"
              ></span>
            </button>
          </div>
          <div *ngIf="resetPasswordForm.get('confirmPassword')?.touched && resetPasswordForm.errors?.['mismatch']" class="text-red-600 text-sm mt-1">
            Passwords do not match.
          </div>
        </div>
      </div>
      <p *ngIf="errorMessage" class="text-red-600 mt-2">{{ errorMessage }}</p>
      <p *ngIf="successMessage" class="text-green-600 mt-2">{{ successMessage }}</p>
    </div>
  </div>

  <div class="w-full mt-4">
    <div class="my-4">
      <app-checkbox formControlName="termsAccepted">
        I accept the
        <a class="underline text-ladder-purpleLight" routerLink="/terms">terms and conditions. </a>
      </app-checkbox>
    </div>
    <app-button type="submit" class="font-bold cursor-pointer" [class.cursor-not-allowed]="resetPasswordForm.invalid || passwordToken" [disabled]="resetPasswordForm.invalid || !passwordToken">Create Account & Sign In</app-button>
    <div class="text-center mt-4">
      <span class="opacity-65 font-semibold mr-3"
        >Already have an account?</span
      >
      <a class="text-ladder-purpleMedium underline font-bold" routerLink="/auth/login">Log in</a>
    </div>
  </div>
</form>
